module.exports = __webpack_public_path__ + "img/map.e356a5ee.svg";